import { inject, InjectionToken } from '@angular/core';

export type RuntimeEnvironment = Record<string, string | number | boolean | null | undefined>;

declare global {
  interface Window {
    ENVIRONMENT: RuntimeEnvironment
  }
}

export const WINDOW = new InjectionToken<Window>('Browser window', { providedIn: 'root', factory: () => window });

export const LOCATION =
  new InjectionToken<Location>('Browser location', { providedIn: 'root', factory: () => location });

export const LOCAL_STORAGE = new InjectionToken<Storage>('Browser local storage', {
  providedIn: 'root',
  factory: () => localStorage
});

export const SESSION_STORAGE = new InjectionToken<Storage>('Browser session storage', {
  providedIn: 'root',
  factory: () => sessionStorage
});

export const RUNTIME_ENVIRONMENT = new InjectionToken<RuntimeEnvironment>('Environment', {
  providedIn: 'root',
  factory: () => inject(WINDOW).ENVIRONMENT ?? {}
});